// Content data for Dependify LLC Nigeria
// AI receptionists, AI employees, WhatsApp automation, appointment setting,
// follow-ups, reminders & confirmations for Nigerian businesses.

export const companyInfo = {
  name: "Dependify LLC Nigeria",
  tagline: "Nigeria's AI Growth & Automation Partner",
  phone: "+234-806-049-6697",
  email: "hello@dependifyllc.com.ng",
  address: "Victoria Island, Lagos, Nigeria",
  logo: "https://customer-assets.emergentagent.com/job_dc770d34-828b-4b4b-a559-1e817f694ac4/artifacts/clet7dsy_dependify_logo.jpg",
  socialLinks: {
    linkedin: "https://www.linkedin.com/company/28927544",
    twitter: "https://twitter.com/dependifyllc",
    instagram: "https://instagram.com/dependifyllc",
    facebook: "https://web.facebook.com/Dependify/"
  }
};

export const stats = [
  { value: "500+", label: "Nigerian Businesses Served" },
  { value: "24/7", label: "AI Coverage — Even Nights & Holidays" },
  { value: "<60s", label: "Average Enquiry Response Time" },
  { value: "98%", label: "Client Satisfaction Rate" }
];

export const services = [
  {
    id: "ai-receptionist",
    title: "AI Receptionist Service",
    shortDesc: "A 24/7 AI receptionist that answers every call and WhatsApp message in seconds",
    description: "Every day, Nigerian businesses lose paying customers to unanswered calls and slow DM replies. Our AI Receptionist answers your calls and WhatsApp messages instantly — 24/7 — with the information your customers actually need: your prices, services, availability and location. It qualifies each enquiry, books appointments straight into your calendar, and hands over to you or your team the moment a conversation needs a human touch.",
    icon: "Bot",
    color: "#10B981",
    features: [
      "24/7 Call Answering with a Natural, Human-like Voice",
      "WhatsApp & Instagram DM Auto-Responses",
      "Instant Answers from Your Business Info (Prices, Hours, Availability)",
      "Lead Qualification & Customer Data Capture",
      "Books Appointments Directly into Your Calendar",
      "Smart Handover to You or Your Team for Complex Issues",
      "Full Message Transcripts & Daily Enquiry Summaries",
      "Conversational English — Friendly to Nigerian Customers"
    ],
    benefits: [
      "Never miss a call or DM again — even at 2 AM",
      "Respond to every enquiry in under 60 seconds",
      "Book more jobs without hiring extra staff",
      "Cut front-desk costs by up to 70% vs a full-time hire"
    ],
    painPoints: [
      "Calls and DMs go unanswered while you're busy or asleep",
      "You can't justify the cost of a full-time front-desk staff",
      "Customers buy from whoever replies first — and it's your competitor",
      "Voicemails and 'call me back' notes are never followed up"
    ],
    pricing: "Starting from ₦75,000/month",
    setupFee: "One-time setup: ₦150,000",
    image: "https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "AI Receptionist Service",
    seoTag: "AI Receptionist"
  },
  {
    id: "ai-employees",
    title: "AI Employees for Nigerian Businesses",
    shortDesc: "Custom-trained AI staff that handle support, admin and sales tasks around the clock",
    description: "An AI Employee is like onboarding your best staff member — one who never sleeps, never resigns and never has a bad day. We train an AI agent on your business: your services, prices, policies, FAQs and tone of voice. It then handles customer support, qualifies leads, captures orders and bookings, updates your records and chases payments — across WhatsApp, email and your website — while you focus on running the business.",
    icon: "BrainCircuit",
    color: "#6366F1",
    features: [
      "Custom-Trained on Your Business, Prices & Policies",
      "Customer Support Across WhatsApp, Email & Web Chat",
      "Lead Qualification & Smart Routing to Your Team",
      "Order & Booking Capture with Automatic Records",
      "CRM / Spreadsheet Updates Without Manual Entry",
      "Automatic Payment Links (Paystack, Flutterwave, Bank Transfer)",
      "Instant Escalation to Humans When Needed",
      "Works 24/7 — No Salaries, No Office, No Leave"
    ],
    benefits: [
      "One AI employee can do the work of 2–3 support staff",
      "Consistent, accurate answers — no bad days or mood swings",
      "Scale up for Detty December or promo periods without hiring",
      "Pay a fraction of a ₦150,000/month salary"
    ],
    painPoints: [
      "You spend hours every day replying to the same questions",
      "Customer messages pile up during your busiest periods",
      "Training new staff every few months is exhausting and expensive",
      "Enquiries die in your DMs because there's no one to respond"
    ],
    pricing: "Starting from ₦150,000/month",
    setupFee: "One-time setup: ₦250,000",
    image: "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "AI Employee Solutions",
    seoTag: "AI Employees"
  },
  {
    id: "whatsapp-automation",
    title: "WhatsApp Business Automation",
    shortDesc: "Turn your WhatsApp into a 24/7 sales, booking and customer-service machine",
    description: "Over 51 million Nigerians use WhatsApp, and it's where your customers already prefer to buy. We set up the official WhatsApp Business Platform for your business with AI-powered auto-replies, smart booking flows, product catalogs and payment links — so every 'How much?' and 'Is it available?' gets an instant, professional answer, even at midnight. No more lost sales to slow replies.",
    icon: "MessageCircle",
    color: "#25D366",
    features: [
      "Official WhatsApp Business API Setup & Meta Verification Guidance",
      "AI Auto-Replies to FAQs (Price, Location, Availability)",
      "Smart Menus & Booking Flows Inside the Chat",
      "Payment Links — Paystack, Flutterwave & Bank Transfer",
      "Broadcast Campaigns to Your Customer Lists",
      "Auto-Catalog of Your Products, Rooms or Services",
      "Multi-Agent Inbox So Your Team Can Join Any Chat",
      "Analytics on Response Times & Chat Conversions"
    ],
    benefits: [
      "Reply to every DM in seconds — even at midnight",
      "Close sales inside the chat where Nigerians already buy",
      "Broadcast offers to thousands of customers instantly",
      "Look professional with an automated, verified business number"
    ],
    painPoints: [
      "Hundreds of unread DMs and 'how much?' messages every week",
      "You repeat the same answers all day, every day",
      "Customers lose patience and buy elsewhere before you reply",
      "Your personal number is tangled up with the business"
    ],
    pricing: "Starting from ₦60,000/month",
    setupFee: "One-time setup: ₦120,000",
    image: "https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "WhatsApp Business Automation",
    seoTag: "WhatsApp"
  },
  {
    id: "appointment-setting",
    title: "AI Appointment Setting",
    shortDesc: "An AI appointment setter that qualifies leads and books them straight into your calendar",
    description: "An enquiry is not an appointment. Our AI Appointment Setter chats with every new lead the moment they arrive — on WhatsApp, Instagram or your website — asks your qualifying questions, answers theirs, and books serious prospects straight into your Google Calendar with automatic confirmations. You simply show up to a calendar full of qualified meetings, viewings or consultations.",
    icon: "CalendarCheck",
    color: "#3B82F6",
    features: [
      "AI Conversations That Qualify (Budget, Timeline, Location, Need)",
      "Real-Time Google & Outlook Calendar Sync",
      "Instant Booking Links Inside WhatsApp, Instagram & Web",
      "Automatic Booking Confirmation Messages",
      "Self-Service Reschedules & Cancellations",
      "Hot-Lead Alerts Straight to Your Phone",
      "Custom Qualifying Questions for Your Industry",
      "Daily Booking Summary Report"
    ],
    benefits: [
      "Wake up to a calendar full of confirmed appointments",
      "Only speak to qualified, serious prospects",
      "Cut no-shows with automatic confirmations and reminders",
      "Books 24/7 — nights, weekends and public holidays"
    ],
    painPoints: [
      "Leads ask questions but you never find time to schedule the call",
      "You waste hours on unqualified 'window shoppers'",
      "Double bookings and missed appointments frustrate your clients",
      "Bookings live in scattered chats you can't track"
    ],
    pricing: "Starting from ₦75,000/month",
    setupFee: "One-time setup: ₦125,000",
    image: "https://images.pexels.com/photos/5940721/pexels-photo-5940721.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Appointment Setting Service",
    seoTag: "Appointments"
  },
  {
    id: "follow-up-automation",
    title: "Automated Follow-Up Systems",
    shortDesc: "Automated follow-up sequences that revive dead leads — 80% of sales need 5+ touches",
    description: "Research shows 80% of sales require five or more follow-ups, yet most businesses stop after one. Our follow-up system does the chasing for you: instant welcome messages for new enquiries, polite nudges after every quote or invoice, revival campaigns for leads that went cold, and win-back offers for old customers — across WhatsApp, SMS and email — all in your brand voice.",
    icon: "Repeat",
    color: "#F59E0B",
    features: [
      "Instant Welcome & Nurture Sequence for Every New Lead",
      "Automatic Follow-Ups After Quotes & Invoices",
      "No-Reply Revival Campaigns",
      "Old-Lead Database Reactivation (WhatsApp, SMS, Email)",
      "Seasonal & Promo Broadcasts (Valentine's, Sallah, Detty December)",
      "Personalised Templates in Your Brand Voice",
      "Smart Channel Mixing — WhatsApp, SMS & Email",
      "Performance Dashboard: Replies, Bookings & Revenue"
    ],
    benefits: [
      "Convert the 8 out of 10 leads that needed one more follow-up",
      "Revive thousands of dormant contacts already in your phone",
      "Stay top-of-mind without lifting a finger",
      "See exactly which follow-ups turn into money"
    ],
    painPoints: [
      "Leads say 'I'll get back to you' — and vanish forever",
      "You forget to follow up because you're busy serving clients",
      "Your old customer list is sitting there doing nothing",
      "Follow-up depends on memory, not a system"
    ],
    pricing: "Starting from ₦50,000/month",
    setupFee: "One-time setup: ₦100,000",
    image: "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Lead Follow-up Automation",
    seoTag: "Follow-up"
  },
  {
    id: "reminders-confirmations",
    title: "Reminders & Confirmations",
    shortDesc: "Automated WhatsApp & SMS reminders and confirmations that cut no-shows by up to 38%",
    description: "No-shows and forgotten payments quietly drain Nigerian businesses every single day — empty appointment slots, unclaimed bookings, awkward payment chasing. We set up automated confirmations the moment a booking is made, plus perfectly timed reminders before every appointment, payment due date or check-in. Customers can confirm, reschedule or ask questions with a simple reply.",
    icon: "BellRing",
    color: "#8B5CF6",
    features: [
      "Instant Booking & Appointment Confirmations",
      "Perfectly Timed Reminders (24 Hours & 1 Hour Before — Your Choice)",
      "Payment Due & Failed Payment Reminders",
      "Check-In Instructions & Balance Payment Notices",
      "Two-Way Replies — Confirm, Reschedule or Cancel",
      "SMS Fallback with DND-Safe Transactional Routing",
      "Custom Templates in English or Pidgin",
      "Delivery Reports for Every Single Message"
    ],
    benefits: [
      "Cut no-shows by up to 38% with well-timed reminders",
      "Get paid faster with polite, automatic payment reminders",
      "Fewer 'I forgot' calls and empty appointment slots",
      "Every client and guest feels professionally attended to"
    ],
    painPoints: [
      "Customers forget appointments and you absorb the loss",
      "Chasing payments feels awkward and takes forever",
      "Guests arrive at the wrong time — or the wrong day",
      "Your staff burn hours every day calling to remind people"
    ],
    pricing: "Starting from ₦40,000/month",
    setupFee: "One-time setup: ₦75,000",
    image: "https://images.pexels.com/photos/955388/pexels-photo-955388.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Reminder & Confirmation Automation",
    seoTag: "Reminders"
  },
  {
    id: "shortlet-automation",
    title: "Shortlet Growth Suite",
    shortDesc: "The complete AI front desk for shortlet apartments in Lagos, Abuja & Port Harcourt",
    description: "Nigerian shortlet guests book whoever replies first — and they message at midnight. The Shortlet Growth Suite is a done-for-you AI front desk for your apartments: it instantly answers availability and price questions, screens guests before you hand over keys, sends booking confirmations with payment details, delivers check-in instructions and house rules, requests reviews after checkout, and alerts your cleaner for the next guest. Built for Lagos, Abuja and Port Harcourt hosts — and ready for Detty December.",
    icon: "BedDouble",
    color: "#EC4899",
    features: [
      "Instant Replies to Availability & Price Questions — 24/7",
      "AI Guest Screening (ID Requests, Scam & Party Filters)",
      "Booking Confirmations with Payment Details (Transfer, Paystack, Flutterwave)",
      "Automated Check-In Instructions, House Rules & Directions",
      "Instant Answers to Amenity Questions ('Do you have 24/7 light?')",
      "Checkout Follow-Ups & Review Requests",
      "Cleaning & Maintenance Alerts to Your Team After Each Guest",
      "Calendar Sync to Prevent Double Bookings"
    ],
    benefits: [
      "Never lose a midnight enquiry to a faster host again",
      "Fewer bad guests with automatic screening",
      "5-star reviews on autopilot with post-checkout follow-ups",
      "Run more apartments without hiring more hands"
    ],
    painPoints: [
      "You're glued to your phone answering 'Is it available?' all day",
      "Guests message at odd hours — and book whoever replies first",
      "Fake transfers and questionable guests stress you out",
      "Turnovers get missed and guests walk into unready apartments"
    ],
    pricing: "Starting from ₦150,000/month",
    setupFee: "One-time setup: ₦250,000",
    image: "https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Shortlet Automation Suite",
    seoTag: "Shortlet"
  },
  {
    id: "shortlet-booking-ai",
    title: "Shortlet Booking AI",
    shortDesc: "Instant availability, price and booking replies for your apartments — 24/7",
    description: "The single biggest reason Nigerian hosts lose bookings is reply speed. Shortlet Booking AI sits on your WhatsApp and Instagram and answers every 'Is it available?', 'How much per night?' and 'Can I see pictures?' in seconds — day or night. It quotes your nightly and weekend rates, applies your minimum-stay and caution-fee rules, sends photos and the apartment location, holds the date while payment is confirmed, and syncs your calendar so two guests never book the same night.",
    icon: "CalendarClock",
    color: "#F59E0B",
    features: [
      "24/7 Instant Replies to Availability & Price Enquiries",
      "Automatic Nightly, Weekend & Long-Stay Rate Quotes",
      "Minimum-Stay, Caution Fee & House Policy Rules Applied Automatically",
      "Photo, Video & Location Sharing Inside the Chat",
      "Provisional Date Holds While Payment Is Confirmed",
      "Calendar Sync Across Apartments to Stop Double Bookings",
      "Payment Links & Bank Transfer Details (Paystack, Flutterwave)",
      "Daily Booking & Enquiry Summary Sent to You"
    ],
    benefits: [
      "Win the booking by replying first — even at 3 AM",
      "Quote consistent prices with no discount confusion",
      "Stop double bookings across multiple apartments",
      "Free your evenings from 'How much?' messages"
    ],
    painPoints: [
      "Enquiries come in at midnight and go cold by morning",
      "You quote different prices to different guests by mistake",
      "Two guests get confirmed for the same night",
      "You lose bookings to hosts who simply replied faster"
    ],
    pricing: "Starting from ₦75,000/month",
    setupFee: "One-time setup: ₦125,000",
    image: "https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Shortlet Booking Automation",
    seoTag: "Shortlet"
  },
  {
    id: "shortlet-guest-screening",
    title: "Shortlet Guest Screening & Fraud Shield",
    shortDesc: "Vet every guest and catch fake transfers before you hand over keys",
    description: "One bad guest can cost you your apartment, your estate relationship and your deposit. Our Guest Screening & Fraud Shield collects each guest's full name, phone number, valid ID and purpose of stay before check-in, flags party bookings and 'I'll pay on arrival' timewasters, and verifies that payment actually landed before the access code is released. Estates across Lagos and Abuja are tightening rules on shortlets — documented screening keeps you on the right side of them.",
    icon: "ShieldCheck",
    color: "#EF4444",
    features: [
      "Automatic ID Collection & Secure Storage Before Check-In",
      "Guest Name, Phone & Purpose-of-Stay Capture",
      "Party & Event Booking Detection with Instant Flagging",
      "Fake Transfer & Fraudulent Payment-Proof Checks",
      "Access Code Released Only After Payment Confirmation",
      "Blocklist of Previously Problematic Guests",
      "Estate & Security Compliance Records for Every Stay",
      "Instant Alert to You When a Booking Looks Risky"
    ],
    benefits: [
      "Keep parties and property damage out of your apartments",
      "Never hand over keys on an unconfirmed payment again",
      "Satisfy estate security with proper guest records",
      "Sleep better knowing every guest has been vetted"
    ],
    painPoints: [
      "Guests send edited transfer receipts that never clear",
      "A 'quiet couple' turns into a 40-person party",
      "Estate management threatens to ban shortlets over unvetted visitors",
      "You feel rude asking every guest for ID — so you skip it"
    ],
    pricing: "Starting from ₦55,000/month",
    setupFee: "One-time setup: ₦100,000",
    image: "https://images.pexels.com/photos/5668859/pexels-photo-5668859.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Shortlet Guest Screening",
    seoTag: "Shortlet"
  },
  {
    id: "shortlet-checkin-automation",
    title: "Shortlet Check-In & House Rules Automation",
    shortDesc: "Every guest gets directions, access codes and house rules — without you typing",
    description: "Check-in is where hosts burn the most time and where guests get the most frustrated. This service sends each confirmed guest a timed sequence: directions and landmarks the day before, gate and access details on arrival day, house rules and Wi-Fi password at check-in, and answers to the questions Nigerian guests always ask — power supply, generator hours, water, parking and security. Checkout reminders go out automatically too, so apartments are freed on time.",
    icon: "KeyRound",
    color: "#0EA5E9",
    features: [
      "Timed Pre-Arrival Directions, Landmarks & Google Maps Pin",
      "Access Codes, Gate Instructions & Security Contact on Arrival Day",
      "House Rules, Wi-Fi Password & Appliance Guides Delivered Automatically",
      "Instant Answers on Power, Generator Hours, Water & Parking",
      "Late Check-In Handling Without Waking You Up",
      "Checkout Reminders with Time and Key-Drop Instructions",
      "Extension & Early-Checkout Requests Routed to You",
      "Full Message Trail per Booking for Dispute Resolution"
    ],
    benefits: [
      "Stop repeating the same check-in message for every guest",
      "Fewer 'I can't find the place' calls at 11 PM",
      "Guests arrive informed, so fewer complaints and refunds",
      "Apartments free up on time for the next booking"
    ],
    painPoints: [
      "You retype directions and Wi-Fi details for every single guest",
      "Guests call you from the gate because security wasn't briefed",
      "Nobody reads the house rules until something breaks",
      "Late checkouts push your cleaner and the next guest behind"
    ],
    pricing: "Starting from ₦45,000/month",
    setupFee: "One-time setup: ₦85,000",
    image: "https://images.pexels.com/photos/271639/pexels-photo-271639.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Shortlet Check-In Automation",
    seoTag: "Shortlet"
  },
  {
    id: "shortlet-review-engine",
    title: "Shortlet Review & Repeat-Booking Engine",
    shortDesc: "Turn every stay into a 5-star review and a returning guest",
    description: "Most Nigerian hosts never ask for reviews, then wonder why new guests hesitate. This engine follows up after checkout at the right moment, asks happy guests for a public review with a direct link, quietly routes unhappy guests to you privately before they post, and keeps your past guests warm with occasional offers — long-weekend deals, Detty December availability and returning-guest discounts — so your calendar fills from people who already trust you.",
    icon: "Star",
    color: "#A855F7",
    features: [
      "Timed Post-Checkout Review Requests with Direct Links",
      "Happy Guests Sent Public, Unhappy Guests Routed to You Privately",
      "Automatic Thank-You Messages and Caution-Fee Refund Notices",
      "Returning-Guest Discount Offers on Autopilot",
      "Seasonal Broadcasts (Detty December, Long Weekends, Public Holidays)",
      "Past-Guest Database Built Automatically From Every Booking",
      "Referral Prompts to Turn Guests Into Promoters",
      "Included Monthly Broadcast Allowance — Extra Sends Billed at Cost",
      "Reporting on Reviews Collected and Repeat Bookings Won"
    ],
    benefits: [
      "More public 5-star reviews without ever asking manually",
      "Catch complaints privately before they become public ratings",
      "Fill low season from guests who already stayed with you",
      "Cut your dependence on paid ads and listing platforms"
    ],
    painPoints: [
      "You forget to ask for reviews, so your listing looks new and risky",
      "A bad review appears before you knew anything was wrong",
      "Past guests disappear and you have no way to reach them",
      "Empty weeks in low season with no one to market to"
    ],
    pricing: "Starting from ₦65,000/month",
    setupFee: "One-time setup: ₦100,000",
    image: "https://images.pexels.com/photos/1579253/pexels-photo-1579253.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Shortlet Review Automation",
    seoTag: "Shortlet"
  },
  {
    id: "shortlet-turnover-ops",
    title: "Shortlet Cleaning & Turnover Coordinator",
    shortDesc: "Your cleaner, maintenance and inventory run themselves between guests",
    description: "The fastest way to lose a 5-star rating is a guest walking into an unready apartment. The Turnover Coordinator alerts your cleaner the moment a guest checks out, sends the exact checklist for that apartment, requires photo proof before the unit is marked ready, and logs low supplies — tissue, water, gas, bulbs — so nothing runs out mid-stay. Maintenance issues get raised to you with pictures instead of dying in a WhatsApp thread.",
    icon: "Sparkles",
    color: "#14B8A6",
    features: [
      "Instant Cleaner Alerts on Checkout and New Booking",
      "Per-Apartment Cleaning Checklists Sent Automatically",
      "Photo Proof Required Before an Apartment Is Marked Ready",
      "Low-Supply Logging (Tissue, Water, Gas, Bulbs, Toiletries)",
      "Maintenance Requests Escalated to You With Pictures",
      "Turnover Time Tracking Across All Your Apartments",
      "Linen & Inventory Records per Unit",
      "Ready/Not-Ready Status Linked to Your Booking Calendar"
    ],
    benefits: [
      "No guest ever walks into an uncleaned apartment",
      "Stop chasing your cleaner for updates on WhatsApp",
      "Catch faults early instead of during a guest's stay",
      "Manage more units without adding a manager"
    ],
    painPoints: [
      "You don't know if the apartment is ready until the guest complains",
      "Your cleaner forgets steps and you only find out later",
      "Gas or water finishes in the middle of a booking",
      "Small faults go unreported until they become expensive"
    ],
    pricing: "Starting from ₦45,000/month",
    setupFee: "One-time setup: ₦85,000",
    image: "https://images.pexels.com/photos/4239146/pexels-photo-4239146.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    type: "Shortlet Operations Automation",
    seoTag: "Shortlet"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Chiamaka Obi",
    role: "Shortlet Host",
    company: "Lekki Stays Collection, Lagos",
    image: "https://images.pexels.com/photos/30677592/pexels-photo-30677592.jpeg?auto=compress&cs=tinysrgb&w=400",
    quote: "Guests used to book whoever replied first — usually not me. Now the AI answers availability questions at 2 AM, confirms payments and sends check-in details automatically. My Lekki apartment stayed booked all through Detty December without me touching my phone.",
    rating: 5,
    result: "54% → 81% occupancy"
  },
  {
    id: 2,
    name: "Dr. Kelechi Nwosu",
    role: "Medical Director",
    company: "Brightsmile Dental Clinic, Port Harcourt",
    image: "https://images.pexels.com/photos/12824196/pexels-photo-12824196.jpeg?auto=compress&cs=tinysrgb&w=400",
    quote: "Our 10 AM slots were a gamble — patients simply forgot. Dependify's confirmations and reminder messages cut our no-shows by more than half within two months. The AI receptionist handles our WhatsApp while our nurses focus on patients.",
    rating: 5,
    result: "No-shows down 60%"
  },
  {
    id: 3,
    name: "Femi Adeyemi",
    role: "Managing Partner",
    company: "Adeyemi & Co. Legal, Abuja",
    image: "https://images.pexels.com/photos/3182781/pexels-photo-3182781.jpeg?auto=compress&cs=tinysrgb&w=400",
    quote: "Potential clients called our office after hours and simply dialed the next lawyer on Google. The AI receptionist now answers every call, explains our services and books consultations. We signed 11 new retainers last quarter from calls we'd normally have missed.",
    rating: 5,
    result: "11 new retainers in one quarter"
  },
  {
    id: 4,
    name: "Amaka Eze",
    role: "CEO",
    company: "GlowTheory Spa & Studio, Lagos",
    image: "https://images.unsplash.com/photo-1646300291345-e7f3f97986ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxOaWdlcmlhbiUyMGJ1c2luZXNzJTIwcHJvZmVzc2lvbmFsJTIwbGFwdG9wfGVufDB8fHwxNzY3OTU4ODA1fDA&ixlib=rb-4.1.0&q=85",
    quote: "Our DMs were chaos — pricing questions, bookings, reschedules. The WhatsApp automation answers instantly, books appointments and sends reminders. Clients actually compliment how fast we reply now. Repeat bookings jumped 40% in three months.",
    rating: 5,
    result: "+40% repeat bookings"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Discovery Call",
    description: "We audit how enquiries reach you today — calls, WhatsApp, Instagram — find exactly where customers slip away, and put a naira figure on what it's costing you.",
    icon: "Phone"
  },
  {
    step: 2,
    title: "Custom AI Blueprint",
    description: "We design your automation: an AI trained on your prices, services and tone of voice, your booking flows and your reminder schedules. You approve everything before we build.",
    icon: "Target"
  },
  {
    step: 3,
    title: "Build & Launch",
    description: "We connect your WhatsApp, phone lines and calendar, train your AI, and test it against real customer scenarios. Most clients go live within 7–14 days.",
    icon: "Rocket"
  },
  {
    step: 4,
    title: "Optimize & Scale",
    description: "We review conversations monthly, tune the AI, and add channels and use cases as you grow — with clear reports on replies, bookings and recovered revenue.",
    icon: "TrendingUp"
  }
];

export const faqs = [
  {
    question: "What exactly is an AI receptionist and how does it work?",
    answer: "An AI receptionist is software we set up and train on your business to answer your customer calls and messages for you. It knows your services, prices, opening hours and availability, answers enquiries instantly (24/7), qualifies each person, books appointments into your calendar, and passes complex conversations to you or your team. It's like having a front-desk officer who never sleeps, never takes leave and answers in seconds."
  },
  {
    question: "Will my Nigerian customers know they are talking to an AI?",
    answer: "The AI is trained to chat naturally the way Nigerians actually communicate — friendly, respectful, and clear in English (Pidgin-friendly where appropriate). If a customer directly asks whether they're speaking to an AI, it discloses honestly and offers a human handover. In our experience, what customers care about most is getting an instant, accurate answer — not whether it comes from software."
  },
  {
    question: "I run a shortlet apartment. How exactly does this help me?",
    answer: "Guests book whoever replies first, and they message at midnight asking 'Is it available?', 'How much per night?' and 'Do you have light?'. Our Shortlet Growth Suite answers all of that instantly, screens guests before you hand over keys, confirms bookings with payment details, sends check-in instructions and house rules automatically, requests reviews after checkout, and alerts your cleaner between stays. Hosts in Lagos, Abuja and Port Harcourt use it to fill more nights — especially during peak periods like Detty December — without being glued to their phones."
  },
  {
    question: "Which channels and tools do you support?",
    answer: "We deploy across the channels your customers already use: WhatsApp (official WhatsApp Business Platform), Instagram DMs, phone calls, SMS and website chat. We integrate with Google and Outlook calendars for booking, and with Paystack, Flutterwave or simple bank-transfer details for payments. Everything feeds into one dashboard so you can see every conversation, booking and reminder."
  },
  {
    question: "Do you use the official WhatsApp Business API?",
    answer: "Yes. We set you up on the official WhatsApp Business Platform (API) — not unofficial bots that risk your number being banned. Meta charges a small per-message fee (for Nigeria, roughly $0.05 for marketing messages and under $0.01 for utility messages like reminders and confirmations, subject to Meta's current rate card). We handle the Meta business registration, number setup and template approvals, and give you full visibility of usage."
  },
  {
    question: "How much does it cost compared to hiring staff?",
    answer: "A customer-service rep or receptionist in Nigeria typically costs ₦70,000–₦150,000+ per month — and works one shift, five days a week. Our AI services start from ₦40,000–₦150,000 per month and work 24/7, including nights, weekends and public holidays, with no recruitment, training or office costs. Most clients start with one service and expand once they see the results."
  },
  {
    question: "How quickly can we go live?",
    answer: "Most clients launch within 7–14 days. Week one covers discovery, the AI blueprint and gathering your business information; week two covers setup, training and testing with real scenarios. WhatsApp templates and sender registrations can add a few days depending on approvals. You approve everything before anything goes live to your customers."
  },
  {
    question: "Will reminders and confirmations really reduce my no-shows?",
    answer: "Yes — it's one of the most studied effects in service businesses. Clinics and salons typically see 15–30% of appointments missed without reminders, and studies show automated SMS/WhatsApp reminders cut no-shows by around 38% on average. In Nigeria, where WhatsApp is the default channel, reminders feel personal and get read. Clients report fewer empty slots, faster payments and far less time spent calling to remind people."
  },
  {
    question: "Is my customers' data safe?",
    answer: "Yes. We operate in line with the Nigeria Data Protection Act 2023. Your customer conversations and data are encrypted, stored securely, never sold, and never used to train public AI models — your AI is trained only on your business information. You retain full ownership of your data, and we can export or delete it on request."
  },
  {
    question: "Do you only work with businesses in Lagos?",
    answer: "No. Our head office is in Lagos, but we serve businesses across Nigeria — Abuja, Port Harcourt, Ibadan, Kano, Enugu, Uyo, Benin City and beyond. Onboarding, training and support all happen online and on WhatsApp, so location is never a barrier. If you prefer in-person onboarding, we can arrange it in Lagos, Abuja and Port Harcourt."
  }
];

export const leadMagnets = {
  whatsapp: {
    title: "FREE: WhatsApp Business Setup Checklist",
    description: "The 12-step checklist Nigerian businesses use to turn WhatsApp into a booking machine — plus the exact auto-reply templates we deploy for clients.",
    cta: "Send Me the Checklist"
  },
  shortlet: {
    title: "FREE: Shortlet Direct-Booking Scorecard",
    description: "Score your apartment's response speed, guest journey and listing quality — and see the exact revenue leaks costing you bookings every month.",
    cta: "Get My Scorecard"
  },
  ai: {
    title: "FREE: AI Readiness Audit",
    description: "In a 15-minute call, we'll map where AI can answer, book and follow up in your business — and what it's currently costing you to do it manually.",
    cta: "Book My Free Audit"
  }
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "How It Works", path: "/how-it-works" },
  { name: "Blog", path: "/blog" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" }
];

export const howItWorks = {
  hero: {
    badge: "How It Works",
    title: "No Facebook Account. No Technical Setup.",
    subtitle: "We handle the entire Meta and WhatsApp side for you. You give us a phone number and read back one code — we do the rest. Your AI goes live in 7–14 days."
  },
  steps: [
    {
      number: "01",
      title: "Free Discovery Call",
      duration: "30 minutes",
      description: "We learn your business: your prices, your services, your busiest hours and the questions customers ask you every single day. For shortlet hosts, that means your apartments, nightly rates, house rules and check-in process.",
      youDo: "Talk to us for 30 minutes.",
      weDo: "Map your enquiry flow and recommend the right service tier."
    },
    {
      number: "02",
      title: "We Set Up the Meta Side",
      duration: "2–3 days",
      description: "This is the part every other vendor asks you to figure out yourself. We create and manage the Meta Business Portfolio and the official WhatsApp Business Account under our verified partner setup. You never log into Facebook, never open Business Manager, and never touch a developer dashboard.",
      youDo: "Give us a phone number and read back one 6-digit code.",
      weDo: "Create the business portfolio, register the number, get your display name approved and submit your message templates to Meta."
    },
    {
      number: "03",
      title: "We Train Your AI",
      duration: "3–5 days",
      description: "We load your prices, policies, FAQs and tone of voice into your AI, then test it against real questions from your own chat history. You review the answers and tell us what to change before a single customer sees it.",
      youDo: "Review a test conversation and give feedback.",
      weDo: "Train, test and tune the AI until it sounds like your business."
    },
    {
      number: "04",
      title: "Go Live & Optimise",
      duration: "Day 7–14",
      description: "Your AI starts answering. We watch every conversation for the first two weeks, fix anything that reads wrong, and send you a weekly summary of enquiries, bookings and handovers. Adjustments stay included in your monthly fee.",
      youDo: "Take the bookings.",
      weDo: "Monitor, tune and report — every month you stay with us."
    }
  ],
  numberOptions: {
    intro: "One honest technical detail nobody else explains upfront: a number connected to the official WhatsApp API can no longer be used in the normal WhatsApp app on a phone. It lives in a shared inbox that you and your team log into instead. There are two ways to handle that, and we help you pick.",
    options: [
      {
        title: "A New Dedicated Number",
        recommended: true,
        forWho: "Recommended for most businesses",
        points: [
          "You keep your existing WhatsApp exactly as it is",
          "We put the new AI number on your listings, website and ads",
          "Nothing is lost — no chat history, no contacts, no disruption",
          "You can migrate your main number later once you trust the system"
        ]
      },
      {
        title: "Migrate Your Main Number",
        recommended: false,
        forWho: "For businesses ready to run on a proper inbox",
        points: [
          "Customers keep messaging the number they already know",
          "Everything lands in one shared inbox your whole team can see",
          "The number leaves the WhatsApp app on your personal phone",
          "Best once you have staff, or if you already feel buried in DMs"
        ]
      }
    ]
  },
  comparison: {
    intro: "Some vendors quote far less than we do. Almost always that is because they connect to WhatsApp through unofficial software that scans a QR code on a personal account. It works — until Meta detects it and permanently bans the number. Here is the difference, in plain terms.",
    rows: [
      {
        point: "How it connects",
        cheap: "Unofficial software pretending to be WhatsApp Web",
        us: "Meta official WhatsApp Cloud API"
      },
      {
        point: "Meta terms of service",
        cheap: "Breaks them by design",
        us: "Fully compliant"
      },
      {
        point: "Risk to your number",
        cheap: "Permanent ban, typically within 2–8 weeks",
        us: "None — the number is registered with Meta"
      },
      {
        point: "If something goes wrong",
        cheap: "No appeal. The number and its history are gone for good",
        us: "Formal support and appeal process through Meta"
      },
      {
        point: "Green verified badge",
        cheap: "Not available",
        us: "Available after business verification"
      },
      {
        point: "What happens at scale",
        cheap: "Risk rises with every message you send",
        us: "Published sending tiers that grow with you"
      }
    ],
    footnote: "Independent research across 600+ small businesses found that 68% using unofficial WhatsApp tools were banned within twelve months. For a shortlet host or a clinic, that number is the business. We will not build your growth on top of it."
  },
  included: {
    title: "What Your Monthly Fee Covers",
    items: [
      "Hosting, monitoring and uptime for your AI",
      "Unlimited prompt and answer updates as your prices change",
      "Adding new FAQs, services or apartments whenever you need",
      "A monthly performance report on enquiries, bookings and handovers",
      "WhatsApp support from a Nigerian team in your timezone",
      "All Meta platform and template management on your behalf"
    ]
  },
  notIncluded: {
    title: "Billed Separately, At Cost",
    intro: "Meta charges per message on the official platform. We pass these through with no markup, and design your flows to keep them as low as possible.",
    items: [
      "About ₦14 per service or utility message beyond your free monthly allowance",
      "About ₦84 per marketing broadcast message",
      "Replies inside an open conversation window are the cheapest path — our flows are built around that",
      "Typical small business: ₦8,000–₦15,000 per month. We estimate yours on the discovery call."
    ]
  },
  faqs: [
    {
      question: "Do I really not need a Facebook account?",
      answer: "Correct. We create and hold the Meta Business Portfolio, so you never sign into Facebook or Business Manager. All we need is a phone number and the 6-digit code Meta sends to it during setup. This is the single most common reason Nigerian businesses stall on WhatsApp automation, and we removed it entirely."
    },
    {
      question: "How long until my AI is live?",
      answer: "Seven to fourteen days for most businesses. The Meta side takes two to three days, training takes three to five, and we spend the rest testing before your customers see anything. Rush setups are possible — ask on the discovery call."
    },
    {
      question: "What happens to my WhatsApp chat history?",
      answer: "Nothing, if you take a new dedicated number — your existing WhatsApp is untouched. If you migrate your main number, the history stays on your phone but future messages arrive in the shared inbox instead. We walk you through the trade-off before you decide."
    },
    {
      question: "Can I cancel? Who owns the WhatsApp account?",
      answer: "You can cancel monthly with 30 days notice. Be aware that a WhatsApp Business Account cannot be transferred between owners once it is created — that is a Meta rule, not ours. If you want the account in your own name from day one, say so on the discovery call and we will set it up that way instead. We would rather explain this upfront than surprise you later."
    },
    {
      question: "Why is there a one-time setup fee?",
      answer: "It covers real work done once: creating and verifying the Meta assets, registering your number, getting your display name and message templates approved, training the AI on your business, and testing it before launch. It is charged once, before we start. Every comparable Nigerian provider charges one."
    },
    {
      question: "What if the AI gets something wrong?",
      answer: "It hands over to you. Every service includes smart handover — when a conversation goes beyond what the AI knows, or a customer asks for a human, it alerts you with the full transcript. We also monitor conversations closely for your first two weeks and tune anything that reads wrong."
    },
    {
      question: "Do you work with businesses outside Lagos?",
      answer: "Yes. Everything is set up and supported remotely, so we serve clients in Abuja, Port Harcourt, Ibadan, Benin and beyond. The discovery call happens on WhatsApp or video, whichever suits you."
    }
  ]
};

export const aboutContent = {
  mission: "To give every Nigerian business — from shortlet hosts to clinics and law firms — an AI workforce that answers, books and follows up as reliably as the biggest companies in the world.",
  vision: "A Nigeria where no business loses a customer to a missed call, a slow reply or a forgotten appointment.",
  story: "Dependify started by helping Nigerian businesses win attention online. But we kept seeing the same thing: businesses winning attention and losing customers at the point of contact — unanswered WhatsApp messages, missed calls, forgotten appointments. So we built our AI practice around fixing exactly that, for the Nigerian market first: WhatsApp-first, naira-friendly, and fluent in how Nigerians actually buy. Today we deploy AI receptionists, AI employees and automation systems for businesses in Lagos, Abuja, Port Harcourt and beyond.",
  values: [
    { title: "Response Time Is Revenue", description: "In our market, the first business to reply usually wins the customer. Everything we build is engineered for speed." },
    { title: "Nigerian First", description: "Built for Nigerian networks, naira payments and how Nigerians actually communicate — WhatsApp first, always." },
    { title: "Results Over Hype", description: "We measure success in booked appointments, filled apartments and recovered revenue — not AI buzzwords." },
    { title: "Human Where It Matters", description: "AI handles the repetitive work; your people handle the moments that need a human touch. That's the right balance." }
  ],
  team: [
    {
      name: "Tolulope Omotosho",
      role: "CEO & Founder",
      image: "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=400",
      bio: "15+ years in digital growth. Now leading Dependify's mission to put practical AI to work for Nigerian businesses — starting with the enquiry-to-booking journey.",
      linkedin: "https://www.linkedin.com/in/tolulopeomotosho/"
    },
    {
      name: "Aisha Mohammed",
      role: "Head of AI & Automation",
      image: "https://images.pexels.com/photos/1181435/pexels-photo-1181435.jpeg?auto=compress&cs=tinysrgb&w=400",
      bio: "Leads the design of Dependify's AI receptionists, WhatsApp automation and workflow systems for the Nigerian market.",
      linkedin: "https://linkedin.com/in/aishamohammed"
    },
    {
      name: "David Okafor",
      role: "Client Success Lead",
      image: "https://images.pexels.com/photos/3182781/pexels-photo-3182781.jpeg?auto=compress&cs=tinysrgb&w=400",
      bio: "Makes sure every client's AI goes live fast and keeps improving — from shortlet hosts in Lagos to clinics in Port Harcourt.",
      linkedin: "https://linkedin.com/in/davidokafor"
    }
  ]
};

export const blogPosts = [
  {
    id: 1,
    slug: "shortlet-booking-automation-nigeria",
    title: "How to Automate Your Shortlet Bookings in Nigeria (2026 Guide for Hosts)",
    excerpt: "Guests book whoever replies first — and they message at midnight. Here's how Nigerian shortlet hosts are using AI and WhatsApp automation to fill more nights without living on their phones.",
    content: `
      <h2>The Shortlet Market Has Changed — Have You?</h2>
      <p>Shortlets are one of Nigeria's hottest property businesses. In Lekki, a decent 2-bedroom can go for <strong>₦100,000–₦200,000 per night</strong>; in Abuja, serviced apartments in Maitama and Wuse range from ₦60,000 to well over ₦400,000 for luxury units; Port Harcourt is not far behind. One fully booked month can out-earn a year of residential rent.</p>
      <p>But here's what most guides won't tell you: <strong>the hosting is not the hard part — the replying is.</strong></p>

      <h2>How Nigerians Actually Book Shortlets</h2>
      <figure>
        <img src="/blog/shortlet-booking-01.webp" alt="Nigerian shortlet host replying to a late-night booking enquiry on her phone" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>Most Nigerian shortlet bookings start as a late-night WhatsApp message — and go to whoever answers first.</figcaption>
      </figure>

      <p>Unlike Europe or the US, most Nigerian shortlet bookings don't start on a booking website. They start in a DM:</p>
      <ul>
        <li>A guest sees your apartment on Instagram or gets your number from a friend</li>
        <li>They send a WhatsApp message: <em>"Is it available this weekend? How much per night?"</em></li>
        <li>They ask the real questions: <em>"Do you have 24/7 light?" "Is there a generator?" "Can I pay half now?"</em></li>
        <li>They wait. And whoever replies first — with answers — gets the booking.</li>
      </ul>
      <p>Research on online leads is brutal: responding within <strong>5 minutes makes you 21x more likely to convert</strong> an enquiry than responding after 30 minutes. Your guest is chatting with three hosts at once. Replying in 4 hours means you were never in the race.</p>

      <h2>The Real Cost of Manual Hosting</h2>
      <p>If you manage your shortlet from your personal WhatsApp, you'll recognise these:</p>
      <ul>
        <li><strong>Midnight enquiries</strong> — guests message at 11 PM; by the time you wake up, they've booked elsewhere</li>
        <li><strong>The same 10 questions every day</strong> — price, availability, power, check-in time, location</li>
        <li><strong>Fake transfers and questionable guests</strong> — and no screening process before handing over keys</li>
        <li><strong>Turnover chaos</strong> — your cleaner finds out about a checkout from you, hours after it should have been done</li>
        <li><strong>Double bookings</strong> — two guests, one apartment, one very awkward phone call</li>
        <li><strong>Silence after checkout</strong> — no review request, so your next guest has no social proof</li>
      </ul>
      <p>Every one of these is a revenue leak. And during peak demand — Detty December, Easter, conference seasons in Abuja — the leaks become floods.</p>

      <h2>What to Automate First (The 7-Piece System)</h2>

      <h3>1. Instant Availability & Price Replies</h3>
      <p>An AI connected to your booking calendar answers "Is it available?" and "How much?" instantly, 24/7, with your real dates and rates — in your voice.</p>

      <h3>2. Guest Screening</h3>
      <p>Before you hand over keys, the AI collects the guest's full name, phone number, purpose of stay and ID. It filters the "come and pay on arrival" timewasters and flags anything suspicious. Estates are cracking down on shortlets precisely because of unvetted visitors — screening protects your relationship with your estate too.</p>

      <h3>3. Booking Confirmation with Payment Details</h3>
      <p>The moment a guest agrees, they receive a professional confirmation with your account details or a Paystack/Flutterwave payment link, your house rules, and the balance deadline.</p>

      <h3>4. Check-In Instructions</h3>
      <p>Directions with a Google Maps link, gate/estate instructions, key or smart-lock details, Wi-Fi password, generator house rules — sent automatically before arrival. Fewer "I'm at the gate" calls.</p>

      <h3>5. Mid-Stay & Checkout Communication</h3>
      <p>A check-in message on the first morning ("Is everything okay with the light and water?") catches problems before they become 1-star reviews.</p>

      <h3>6. Cleaning & Turnover Alerts</h3>
      <p>The moment a guest checks out, your cleaner gets an automatic alert with the checkout time and any guest notes. No more guests walking into unready apartments.</p>

      <h3>7. Review Requests & Repeat-Booking Offers</h3>
      <p>After checkout, the AI thanks the guest, asks for a review, and offers a return-booking discount. Reviews are what make your next ten bookings easier.</p>

      <h2>What Results Do Hosts See?</h2>
      <figure>
        <img src="/blog/shortlet-booking-02.webp" alt="Clean serviced apartment bedroom prepared for a guest check-in" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>Automated turnover alerts mean the apartment is ready before the guest reaches the gate.</figcaption>
      </figure>

      <p>Hosts running this kind of system typically report:</p>
      <ul>
        <li>Response times dropping from hours to <strong>under 60 seconds</strong>, around the clock</li>
        <li>Meaningfully higher occupancy — especially on weekdays and low season, when every saved enquiry counts</li>
        <li>Fewer bad guests, fewer missed turnovers, and a steady stream of fresh reviews</li>
        <li>The freedom to run two, three, five apartments — without hiring a team</li>
      </ul>

      <blockquote>"Guests used to book whoever replied first — usually not me. Now the AI answers at 2 AM, confirms payments and sends check-in details automatically. My Lekki apartment stayed booked all through Detty December without me touching my phone." — Chiamaka O., Shortlet Host, Lagos</blockquote>

      <h2>Start Small, Then Scale</h2>
      <p>You don't need to automate everything on day one. Start with instant replies and booking confirmations — the two biggest revenue leaks — then add screening, check-in instructions and review requests.</p>

      <p>Want a done-for-you version? Our <a href="/services/shortlet-automation">Shortlet Growth Suite</a> sets all of this up for apartments in Lagos, Abuja, Port Harcourt and beyond. <a href="/contact">Book a free demo</a> and we'll show you exactly how it would work with your apartments.</p>

      <p>Related reading: <a href="/blog/whatsapp-business-automation-nigeria">WhatsApp Business Automation in Nigeria: The Complete Guide</a></p>
    `,
    image: "https://images.pexels.com/photos/2635038/pexels-photo-2635038.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    author: {
      name: "Tolulope Omotosho",
      image: "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=400",
      linkedin: "https://www.linkedin.com/in/tolulopeomotosho/"
    },
    publishedDate: "2026-08-20",
    modifiedDate: "2026-09-08",
    category: "Shortlet Automation",
    tags: ["Shortlet", "Automation", "Nigeria", "Lagos", "WhatsApp", "Real Estate"],
    readTime: "9 min read",
    relatedPosts: ["whatsapp-business-automation-nigeria", "appointment-reminders-no-shows-nigeria"]
  },
  {
    id: 2,
    slug: "whatsapp-business-automation-nigeria",
    title: "WhatsApp Business Automation in Nigeria: The Complete 2026 Guide",
    excerpt: "51 million Nigerians use WhatsApp — and your customers expect an instant reply there. Learn how the official WhatsApp Business API works, what it costs, and how to automate sales, bookings and support.",
    content: `
      <h2>Why WhatsApp Is Nigeria's Real Marketplace</h2>
      <p>Nigeria has roughly <strong>51 million active WhatsApp users</strong> — the 10th largest WhatsApp population in the world — and surveys put adoption at <strong>95%+ of internet users</strong>. For Nigerian customers, WhatsApp isn't "a messaging app"; it's how they ask about prices, place orders, confirm bookings and complain when something goes wrong.</p>
      <p>If your business replies to WhatsApp hours later — or not at all — you're not competing in the market. You're watching it pass by.</p>

      <h2>The Problem With "Normal" WhatsApp</h2>
      <figure>
        <img src="/blog/whatsapp-automation-01.webp" alt="Nigerian shop owner handling customer enquiries on WhatsApp from behind his counter" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>On a personal WhatsApp, every enquiry competes with everything else the owner is doing.</figcaption>
      </figure>

      <p>Most Nigerian businesses run customer conversations on a personal or regular WhatsApp number. That creates problems you already know:</p>
      <ul>
        <li>One phone, one person — every enquiry waits for <em>you</em></li>
        <li>The same "How much? Do you deliver?" questions answered 50 times a day</li>
        <li>No structure: no catalog, no saved templates, no records, no handover when you're busy</li>
        <li>Unofficial "auto-reply bots" that risk your number being banned</li>
      </ul>

      <h2>The Fix: The Official WhatsApp Business Platform</h2>
      <p>The WhatsApp Business Platform (API) is Meta's official channel for businesses. It's what banks, airlines and big e-commerce brands use — and it's now accessible and affordable for Nigerian SMEs. With it you can:</p>
      <ul>
        <li><strong>Automate instant answers</strong> — an AI trained on your business replies to price, availability and service questions 24/7</li>
        <li><strong>Build smart flows</strong> — menus, booking steps, order capture and qualification, all inside the chat</li>
        <li><strong>Collect payments</strong> — send Paystack, Flutterwave or bank-transfer details and confirm orders without leaving WhatsApp</li>
        <li><strong>Broadcast offers</strong> — send promotions to opted-in customer lists (with template approval, so no spam)</li>
        <li><strong>Give your team a shared inbox</strong> — multiple staff can join the same chat with full history</li>
        <li><strong>Stay verified</strong> — work toward the verified business badge customers trust</li>
      </ul>

      <h2>What It Costs in Nigeria (2026)</h2>
      <p>Since July 2025, Meta charges <strong>per message delivered</strong> (instead of per conversation). For Nigeria, rates are among the lowest in the world:</p>
      <ul>
        <li><strong>Utility messages</strong> (confirmations, reminders, receipts): under $0.01 per message</li>
        <li><strong>Marketing messages</strong> (offers, broadcasts): about $0.05 per message</li>
        <li>Customer service replies within an open 24-hour window: free</li>
      </ul>
      <p>Compare that to what one lost sale costs your business, and the maths is not close.</p>

      <h2>What Nigerian Businesses Automate First</h2>
      <figure>
        <img src="/blog/whatsapp-automation-02.webp" alt="Nigerian business owner away from her phone while her AI handles enquiries" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>Once the first replies are automated, the owner stops living inside the inbox.</figcaption>
      </figure>

      <h3>Shortlets & Real Estate</h3>
      <p>Availability replies, price quotes, viewings bookings, check-in instructions — see our full <a href="/services/shortlet-automation">Shortlet Growth Suite</a>.</p>
      <h3>Clinics & Spas</h3>
      <p>Appointment booking, confirmations and reminders, service menus, payment reminders.</p>
      <h3>Professional Services</h3>
      <p>Lead qualification, consultation booking, document checklists, fee quotes.</p>
      <h3>Retail & Logistics</h3>
      <p>Order capture, delivery status updates, dispatch rider coordination, payment confirmation.</p>

      <h2>Common Mistakes to Avoid</h2>
      <ul>
        <li><strong>Using unofficial bots</strong> — they violate Meta's terms and can get your number banned. Always use the official API.</li>
        <li><strong>Blasting marketing messages without opt-in</strong> — it kills your quality rating and delivery.</li>
        <li><strong>Automating everything including complaints</strong> — angry customers need a human. Good automation knows when to hand over.</li>
        <li><strong>Ignoring SMS fallback</strong> — some contacts won't receive promotional messages due to DND settings on Nigerian networks; transactional messages like reminders route differently. A mixed WhatsApp + SMS system covers everyone.</li>
      </ul>

      <h2>How to Get Started</h2>
      <p>1. Register your business on Meta Business Manager.<br/>
      2. Set up the official WhatsApp Business Platform with an approved display name.<br/>
      3. Train an AI on your prices, services, FAQs and tone of voice.<br/>
      4. Connect your calendar and payment links.<br/>
      5. Start with auto-replies + booking, then add broadcasts and reminders.</p>
      <p>Or skip the setup headache: our <a href="/services/whatsapp-automation">WhatsApp Business Automation service</a> handles all of this for you — live in as little as 7 days. <a href="/contact">Talk to us</a> and we'll audit your current WhatsApp setup for free.</p>

      <p>Related reading: <a href="/blog/what-is-an-ai-employee-nigeria">What Is an AI Employee? A Guide for Nigerian Businesses</a></p>
    `,
    image: "https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    author: {
      name: "Aisha Mohammed",
      image: "https://images.pexels.com/photos/1181435/pexels-photo-1181435.jpeg?auto=compress&cs=tinysrgb&w=400",
      linkedin: "https://linkedin.com/in/aishamohammed"
    },
    publishedDate: "2026-08-12",
    modifiedDate: "2026-09-08",
    category: "WhatsApp Marketing",
    tags: ["WhatsApp", "Automation", "Nigeria", "AI", "Sales"],
    readTime: "10 min read",
    relatedPosts: ["shortlet-booking-automation-nigeria", "ai-receptionist-vs-human-receptionist-nigeria"]
  },
  {
    id: 3,
    slug: "ai-receptionist-vs-human-receptionist-nigeria",
    title: "AI Receptionist vs Human Receptionist in Nigeria: Which Should You Hire?",
    excerpt: "A receptionist in Nigeria costs ₦70,000–₦150,000/month and works one shift. An AI receptionist costs less and works 24/7. Here's an honest comparison — including when you still need a human.",
    content: `
      <h2>The Question Every Nigerian Business Owner Is Asking</h2>
      <p>Your phone rings while you're in a meeting. Your WhatsApp is blowing up while you sleep. A front-desk hire would fix it — but is an AI receptionist a real alternative, or just hype?</p>
      <p>Here's the honest comparison, with real Nigerian numbers.</p>

      <h2>The Cost Comparison</h2>
      <figure>
        <img src="/blog/ai-receptionist-02.webp" alt="Receptionist attending to a walk-in client at an office front desk" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>A human receptionist is unbeatable face to face — and expensive to keep on duty 24/7.</figcaption>
      </figure>

      <p>A customer service representative or receptionist in Nigeria typically earns <strong>₦70,000–₦150,000 per month</strong> in most cities (entry roles can be lower; senior or expat-facing roles higher). Add recruitment, training, software, and the reality of leave, sick days and turnover.</p>
      <p>An AI receptionist from Dependify starts at <strong>₦75,000/month</strong> — and works every hour of every day, including nights, weekends and public holidays.</p>
      <p>But cost is the wrong comparison on its own. Here's the full picture:</p>

      <h3>Where a Human Receptionist Wins</h3>
      <ul>
        <li>Warm, physical welcome for walk-in visitors</li>
        <li>Complex negotiations and emotional conversations</li>
        <li>Tasks that need physical presence — handling parcels, managing the lobby</li>
      </ul>

      <h3>Where an AI Receptionist Wins</h3>
      <ul>
        <li><strong>Coverage:</strong> 24/7/365. Studies show small businesses miss 20–35% of calls even during office hours — and nearly 100% after hours. Between 40–60% of revenue-generating calls come in outside 9–5.</li>
        <li><strong>Speed:</strong> answers in under a second, every time. Speed matters — businesses that respond within 5 minutes are 21x more likely to convert an enquiry.</li>
        <li><strong>Consistency:</strong> it never gives the wrong price, forgets a promo, or has a bad day.</li>
        <li><strong>Scale:</strong> 3 simultaneous calls and 30 WhatsApp chats? No problem. No queue, no "please hold".</li>
        <li><strong>Memory:</strong> every conversation is transcribed and summarised for you.</li>
      </ul>

      <h2>The Missed-Call Maths (Do This for Your Business)</h2>
      <figure>
        <img src="/blog/ai-receptionist-01.webp" alt="Empty reception desk with an unattended phone and appointment book" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>Every hour the desk is empty is an hour of enquiries going to a competitor.</figcaption>
      </figure>

      <p>Take your average customer value — say <strong>₦150,000</strong> for a shortlet booking season, a legal retainer or a dental treatment plan. Now estimate:</p>
      <ul>
        <li>Enquiries you receive per week: ___</li>
        <li>% that reach you late or never: even a conservative 25% ___</li>
        <li>% of those that would have booked: even 30% ___</li>
      </ul>
      <p>For a business with 40 weekly enquiries, that's roughly 3 lost bookings a week — <strong>₦1.8M+ a month</strong> in our example. A full-time receptionist catching only office hours still misses the nights and weekends.</p>

      <h2>So… Which One?</h2>
      <p>For most Nigerian SMEs we serve — shortlets, clinics, law firms, spas, logistics — the winning setup is <strong>AI first, human for what matters</strong>:</p>
      <ul>
        <li>The AI answers everything instantly, 24/7, and books appointments</li>
        <li>Complex or high-emotion conversations are handed to you or your team with full context</li>
        <li>You keep one human where the physical welcome matters (or none, if you have no walk-ins)</li>
      </ul>
      <p>That combination typically costs less than one junior hire — and covers the 128 hours a week a 9-to-5 receptionist doesn't.</p>

      <h2>Try It Before You Decide</h2>
      <p>We'll set up a live demo trained on <em>your</em> business — your services, your prices, your tone — and you can interrogate it yourself. <a href="/contact">Book your free demo</a> or learn more about our <a href="/services/ai-receptionist">AI Receptionist service</a>.</p>

      <p>Related reading: <a href="/blog/whatsapp-business-automation-nigeria">WhatsApp Business Automation in Nigeria</a></p>
    `,
    image: "https://images.pexels.com/photos/8867482/pexels-photo-8867482.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    author: {
      name: "Tolulope Omotosho",
      image: "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=400",
      linkedin: "https://www.linkedin.com/in/tolulopeomotosho/"
    },
    publishedDate: "2026-07-28",
    modifiedDate: "2026-09-08",
    category: "AI Receptionist",
    tags: ["AI Receptionist", "Cost", "Nigeria", "Hiring", "AI"],
    readTime: "8 min read",
    relatedPosts: ["what-is-an-ai-employee-nigeria", "appointment-reminders-no-shows-nigeria"]
  },
  {
    id: 4,
    slug: "appointment-reminders-no-shows-nigeria",
    title: "How Automated Reminders Cut No-Shows by 38% (A Guide for Nigerian Businesses)",
    excerpt: "Empty slots, forgotten bookings, awkward payment chasing — no-shows quietly drain Nigerian clinics, salons, shortlets and consultants. Here's what the research says and how to fix it with WhatsApp and SMS reminders.",
    content: `
      <h2>The Silent Revenue Killer</h2>
      <figure>
        <img src="/blog/reminders-noshows-01.webp" alt="Empty consulting room chair, representing a missed appointment" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>An empty chair at 10 AM is revenue that cannot be sold again.</figcaption>
      </figure>

      <p>Across service industries, <strong>15–30% of scheduled appointments end as no-shows</strong> when there's no reminder system. For a clinic, that's a doctor standing idle. For a salon, a chair earning nothing. For a shortlet, a night that can never be re-sold. For a consultant, a morning commute to an empty seat.</p>
      <p>The research on reminders is one of the clearest findings in service operations: in a landmark study of over 13,000 appointments, no-show rates fell from <strong>23.1% with no reminders to 17.3% with automated text reminders</strong> — and automated reminders across industries cut no-shows by <strong>around 38%</strong> on average, with multi-channel reminders (SMS + WhatsApp + voice) reaching 40–60% reductions.</p>

      <h2>Why Nigerians Miss Appointments (It's Not Rudeness)</h2>
      <ul>
        <li><strong>Life happens:</strong> traffic on Third Mainland Bridge, a generator issue, a school run that ran long</li>
        <li><strong>Genuine forgetting:</strong> a booking made 3 weeks ago with nothing in between</li>
        <li><strong>No easy way to reschedule:</strong> calling to move an appointment feels like a hassle, so people just… don't show</li>
        <li><strong>Low commitment:</strong> free bookings and "I'll confirm later" carry no stake</li>
      </ul>
      <p>Notice: none of these are malice. They're all fixable with well-timed, low-friction communication.</p>

      <h2>The Reminder System That Works</h2>
      <figure>
        <img src="/blog/reminders-noshows-02.webp" alt="Client checking an appointment reminder on her phone as she leaves home" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>A reminder that lands the evening before is what turns a booking into an arrival.</figcaption>
      </figure>


      <h3>1. Confirm Instantly at Booking</h3>
      <p>A confirmation the moment a booking is made — date, time, location (with a maps link), what to bring, and payment status — sets the commitment early. Instant confirmations also catch wrong numbers immediately.</p>

      <h3>2. Remind 24 Hours Before</h3>
      <p>This is the workhorse. It gives people time to reschedule if they must — which paradoxically protects your calendar, because a reschedule a day early is a slot you can still refill.</p>

      <h3>3. Remind 1–2 Hours Before</h3>
      <p>The "leave now" nudge. Short, friendly, with the address or check-in details again.</p>

      <h3>4. Make Replying Easy</h3>
      <p>Every message should be two-way: "Reply 1 to confirm, 2 to reschedule." One tap beats one phone call.</p>

      <h3>5. Automate Payment Reminders Too</h3>
      <p>Balance payments, deposit deadlines, overdue invoices — polite, automatic, dated. Clients pay faster when the reminder isn't awkward for anyone.</p>

      <h3>6. Use WhatsApp First, SMS as Backup</h3>
      <p>WhatsApp is where Nigerians read messages. But smart systems keep SMS as a fallback — and route transactional messages correctly, since promotional SMS can be blocked by DND settings on Nigerian networks while transactional messages get through.</p>

      <h2>Industry Playbooks</h2>
      <ul>
        <li><strong>Clinics & med-spas:</strong> confirmation at booking + 24h and 2h reminders + reschedule links. No-shows typically drop by a third or more within the first month.</li>
        <li><strong>Salons & studios:</strong> reminder at 24h + easy "Reply to rebook" after the visit — this doubles as your repeat-booking engine.</li>
        <li><strong>Shortlets:</strong> balance-payment reminders before check-in + check-in instructions the day of arrival + checkout and review messages after.</li>
        <li><strong>Consultants & law firms:</strong> meeting confirmations with agendas + reschedule links + post-meeting follow-ups.</li>
      </ul>

      <h2>What It Costs vs What It Saves</h2>
      <p>Our <a href="/services/reminders-confirmations">Reminders & Confirmations service</a> starts from ₦40,000/month. If your average appointment or booking is worth ₦25,000, saving just two no-shows a month covers it — and most clients save far more, plus hours of staff calling time.</p>

      <p><a href="/contact">Book a free consultation</a> and we'll map your reminder flows — booking, payment and check-in — for your exact business.</p>

      <p>Related reading: <a href="/blog/ai-receptionist-vs-human-receptionist-nigeria">AI Receptionist vs Human Receptionist in Nigeria</a></p>
    `,
    image: "https://images.pexels.com/photos/4126724/pexels-photo-4126724.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    author: {
      name: "David Okafor",
      image: "https://images.pexels.com/photos/3182781/pexels-photo-3182781.jpeg?auto=compress&cs=tinysrgb&w=400",
      linkedin: "https://linkedin.com/in/davidokafor"
    },
    publishedDate: "2026-07-15",
    modifiedDate: "2026-09-08",
    category: "Reminders & No-Shows",
    tags: ["Reminders", "No-Shows", "Appointments", "Nigeria", "WhatsApp"],
    readTime: "7 min read",
    relatedPosts: ["shortlet-booking-automation-nigeria", "ai-receptionist-vs-human-receptionist-nigeria"]
  },
  {
    id: 5,
    slug: "what-is-an-ai-employee-nigeria",
    title: "What Is an AI Employee? A Plain-Language Guide for Nigerian Businesses",
    excerpt: "No robots, no sci-fi. An AI employee is software trained on your business that handles support, bookings, follow-ups and admin — 24/7. Here's what it can (and can't) do, and what it costs in Nigeria.",
    content: `
      <h2>Forget the Robot Image</h2>
      <p>An "AI employee" isn't a robot and it isn't science fiction. It's software — trained on <em>your</em> business — that does knowledge work: answering customer questions, booking appointments, qualifying leads, capturing orders, updating records and chasing payments. Think of it as onboarding a staff member who reads your entire business manual on day one and never forgets any of it.</p>
      <p>Nigeria is already one of the most AI-curious markets on earth: a 2025 Google/Ipsos survey found <strong>70% of Nigerians reported using generative AI in the past year</strong> — well above the 48% global average — and business surveys report the majority of Nigerian firms are moving AI from experiments into daily operations. The question is no longer <em>whether</em> Nigerian businesses will use AI staff, but <em>who sets theirs up properly first</em>.</p>

      <h2>What an AI Employee Actually Does</h2>
      <figure>
        <img src="/blog/ai-employee-01.webp" alt="Small Nigerian business team working together in a compact office" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>An AI employee takes the repetitive work off the team — it does not replace the team.</figcaption>
      </figure>

      <h3>1. Customer Support, Around the Clock</h3>
      <p>Answers the same questions endlessly and cheerfully: prices, availability, delivery areas, how it works. Across WhatsApp, email and your website — simultaneously.</p>
      <h3>2. Booking & Order Capture</h3>
      <p>Takes bookings straight into your calendar, captures orders with the right details, and sends payment links (Paystack, Flutterwave, bank transfer).</p>
      <h3>3. Lead Qualification</h3>
      <p>Asks your qualifying questions — budget, timeline, location, need — and routes hot leads to you with a summary, while politely nurturing the rest.</p>
      <h3>4. Admin & Records</h3>
      <p>Logs every conversation into your CRM or spreadsheet, sends confirmations and reminders, and follows up on quotes and invoices.</p>
      <h3>5. Escalation to Humans</h3>
      <p>When a conversation needs a human — a complaint, a negotiation, anything emotional — it hands over to your team with the full history. This is the mark of a properly built system.</p>

      <h2>What an AI Employee Can't Do (Yet)</h2>
      <ul>
        <li>Physical tasks — it can't hand over keys or examine a patient</li>
        <li>Genuinely novel negotiations or emotional situations</li>
        <li>Decisions that need your judgement — it follows <em>your</em> rules</li>
      </ul>
      <p>That's why the right model is an <strong>AI + human team</strong>, not AI instead of humans. The AI absorbs the repetitive 80% so your people can focus on the 20% that needs them.</p>

      <h2>The Cost Question</h2>
      <figure>
        <img src="/blog/ai-employee-02.webp" alt="Nigerian entrepreneur working late at a home office desk" width="1216" height="704" loading="lazy" decoding="async" />
        <figcaption>The work does not stop at 6 PM — but the salary bill does not have to follow it.</figcaption>
      </figure>

      <p>A customer-service hire in Nigeria costs roughly <strong>₦70,000–₦150,000/month</strong>, works one shift, and needs training every time they move on. An AI employee from Dependify starts at <strong>₦150,000/month</strong>, works 24/7 across every channel at once, and is trained once — on your information, your policies, your tone.</p>
      <p>The honest framing: it's not "AI vs staff". It's "one AI employee doing the work of 2–3 support staff" — at a fraction of the total cost.</p>

      <h2>How to Start (Without Betting the Business)</h2>
      <ol>
        <li><strong>Pick one painful workflow</strong> — usually "answering the same WhatsApp questions" or "following up on quotes"</li>
        <li><strong>Give the AI your knowledge</strong> — prices, services, policies, FAQs. We do this with you in a structured session</li>
        <li><strong>Run it alongside yourself for two weeks</strong> — review every conversation, tune the answers</li>
        <li><strong>Expand</strong> — add channels, add booking, add reminders, one piece at a time</li>
      </ol>

      <p>Our <a href="/services/ai-employees">AI Employees service</a> includes the training, setup and ongoing tuning. Or start smaller with a <a href="/services/ai-receptionist">24/7 AI Receptionist</a> and grow from there. <a href="/contact">Book a free AI readiness audit</a> — 15 minutes, and we'll map exactly where AI can earn its keep in your business.</p>

      <p>Related reading: <a href="/blog/whatsapp-business-automation-nigeria">WhatsApp Business Automation in Nigeria: The Complete Guide</a></p>
    `,
    image: "https://images.pexels.com/photos/1181435/pexels-photo-1181435.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    author: {
      name: "Aisha Mohammed",
      image: "https://images.pexels.com/photos/1181435/pexels-photo-1181435.jpeg?auto=compress&cs=tinysrgb&w=400",
      linkedin: "https://linkedin.com/in/aishamohammed"
    },
    publishedDate: "2026-06-30",
    modifiedDate: "2026-09-08",
    category: "AI Employees",
    tags: ["AI Employees", "AI", "Nigeria", "Automation", "Business"],
    readTime: "9 min read",
    relatedPosts: ["ai-receptionist-vs-human-receptionist-nigeria", "whatsapp-business-automation-nigeria"]
  }
];
